module.exports = __webpack_public_path__ + "static/img/mobilepay-logo-white.c94cd420.svg";